var UserGroupListItemUser = /** @class */ (function () {
    function UserGroupListItemUser(obj) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.disabled = obj && obj.disabled || false;
    }
    return UserGroupListItemUser;
}());
export { UserGroupListItemUser };
